module.exports = __webpack_public_path__ + "img/湖畔庇佑.be0f9a47.webp";